import * as THREE from 'three';

/**
 * CanvasTexture atlas: left cell = "0", right cell = "1".
 * Chosen over per-mesh CanvasTexture for one bind; pairs with InstancedMesh + shader sampling.
 */
export class BinaryAtlas {
  /** @param {{ pixelSize?: number }} [options] */
  constructor({ pixelSize = 96 } = {}) {
    this.pixelSize = pixelSize;
    this.texture = this._buildTexture();
  }

  _buildTexture() {
    const cell = this.pixelSize;
    const canvas = document.createElement('canvas');
    canvas.width = cell * 2;
    canvas.height = cell;

    const ctx = canvas.getContext('2d');
    if (!ctx) {
      throw new Error('Could not create binary atlas canvas context.');
    }

    ctx.fillStyle = '#000000';
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    ctx.fillStyle = '#ffffff';
    ctx.font = `700 ${Math.floor(cell * 0.82)}px "Consolas", "Courier New", monospace`;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText('0', cell * 0.5, cell * 0.52);
    ctx.fillText('1', cell * 1.5, cell * 0.52);

    const texture = new THREE.CanvasTexture(canvas);
    texture.colorSpace = THREE.SRGBColorSpace;
    texture.wrapS = THREE.ClampToEdgeWrapping;
    texture.wrapT = THREE.ClampToEdgeWrapping;
    texture.minFilter = THREE.LinearFilter;
    texture.magFilter = THREE.LinearFilter;
    texture.needsUpdate = true;
    return texture;
  }

  dispose() {
    this.texture.dispose();
  }
}
